import { Link } from "react-router-dom";
import { ArrowRight, Activity } from "lucide-react";

export default function QuizTeaser() {
  return (
    <section className="py-20 md:py-28" data-testid="quiz-teaser">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="relative bg-white border border-slate-200 p-8 md:p-14 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-teal-700 mb-3">
              <Activity className="h-4 w-4" strokeWidth={2} />
              60-Second Quiz
            </div>
            <h3 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-900 leading-[1.04] mb-4">
              How healthy is your <br />
              <span className="font-editorial italic font-medium text-slate-700">mature & tail-end portfolio?</span>
            </h3>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed max-w-xl">
              Answer 5 quick questions. Get an instant estimate of untapped extra-urban revenue
              and potential annual OPEX savings — tailored to your portfolio size.
            </p>
          </div>
          <div className="lg:col-span-5 flex lg:justify-end">
            <Link
              to="/quiz"
              data-testid="quiz-teaser-cta"
              className="inline-flex items-center gap-2 btn-accent px-7 py-4 text-sm font-semibold"
            >
              Take the Portfolio Health Quiz <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
